export const ROUTES = {
    DASHBOARD:"/oppdb/app/dashboard",
    HOME:"/oppdb/",
    LOGIN:"/oppdb/auth/login",
}